<template>
  <div class="page-filters card mb-3 px-4 pb-4">
    <div class="top-banner"><span class="ms-2">Filters</span></div>
    <div v-if="filtersReady" class="filter-toggles">
      <div
        v-for="(filters, key) in pageFiltersByGroup"
        :key="key"
        class="filter-group"
      >
        <strong class="label">{{ key }} </strong>
        <div
          v-for="filter in filters"
          :key="filter.field"
          class="d-flex gap-2 align-items-center"
        >
          <div v-if="filter.inputType === 'checkbox'" class="d-flex gap-2">
            <input
              v-model="computedTabulatorPageFilters[filter.field].isActive"
              :disabled="computedTabulatorPageFilters[filter.field].isDisabled"
              :type="filter.inputType"
            />
            <label>{{ filter.label }}</label>
          </div>
          <div v-if="filter.inputType === 'radio'" class="d-flex gap-3">
            <div
              v-for="option in filter.options"
              :key="option.value"
              class="d-flex align-items-center gap-1"
            >
              <input
                :id="option.label"
                :key="option.value"
                v-model="computedTabulatorPageFilters[filter.field].value"
                :checked="
                  computedTabulatorPageFilters[filter.field].value === option.value
                "
                :disabled="computedTabulatorPageFilters[filter.field].isDisabled"
                :value="option.value"
                type="radio"
              />
              <label :for="option.label">{{ option.label }}</label>
            </div>
          </div>
          <div v-if="filter.inputType === 'select'">
            <select
              v-model="computedTabulatorPageFilters[filter.field].value"
              :disabled="computedTabulatorPageFilters[filter.field].isDisabled"
              class="form-select"
            >
              <option
                v-for="option in filter.options"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import useTabulatorPageFilterStore from "@root/store/useTabulatorPageFilterStore";

const props = defineProps({
  pageFilters: {
    type: Array,
  }
});

const tabulatorPageFilterStore = useTabulatorPageFilterStore();
const filtersReady = ref(false);

const computedTabulatorPageFilters = computed(() => tabulatorPageFilterStore.pageFilters);
const activeHeaderFilters = computed(() => tabulatorPageFilterStore.activeHeaderFilters);

const pageFiltersByGroup = computed(() => {
  return props.pageFilters.reduce((groups, filter) => {
    if (!groups[filter.filterGroup]) {
      groups[filter.filterGroup] = [];
    }
    groups[filter.filterGroup].push(filter);
    return groups;
  }, {});
});

watch(() => activeHeaderFilters.value, (newFilters) => {
  // if header filter also has a page filter - disable the page filter
  Object.values(tabulatorPageFilterStore.pageFilters).forEach((tabulatorPageFilter) => {
    const isActiveInHeader = newFilters.some(
      (headerFilter) => headerFilter.field === tabulatorPageFilter.field,
    );
    tabulatorPageFilter.isDisabled = isActiveInHeader;
  });

}, { deep: true });

onUnmounted(() => tabulatorPageFilterStore.setPageFilters({}))

onMounted(() => {
  tabulatorPageFilterStore.setPageFilters(
    props.pageFilters.reduce((obj, value) => {
      obj[value.field] = { isDisabled: false, ...value };
      return obj;
    }, {}),
  );
  nextTick(() => {
    filtersReady.value = true;
  });
});
</script>

<style lang="scss" scoped>
.filter-group {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;

  input[type="radio"] {
    accent-color: #4e7680;
  }
}

.top-banner {
  background-color: #4e7680;
  color: #fff;
  font-weight: bold;
  padding-block: 0.5rem;
  margin-bottom: 1rem;
  width: calc(100% + 3rem);
  margin-left: -1.5rem;
}

.label {
  text-transform: capitalize;
  width: 120px;
}

.page-filters {
  overflow: hidden;
  grid-area: filters;
}
</style>
